import { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

export type StatsDropdownProps = {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  minWidth?: number;
};

export function StatsDropdown({ options, value, onChange, minWidth = 168 }: StatsDropdownProps) {
  const [open, setOpen] = useState(false);

  return (
    <FormControl
      sx={{
        minWidth: minWidth,
        position: 'relative',
      }}
    >
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: '#181818',
              color: 'white',
              fontFamily: 'Plus Jakarta Sans',
              fontSize: '13px',
              borderRadius: '8px',
              border: '1px solid #323232',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.6)',
            },
          },
        }}
        sx={{
          height: '40px',
          borderRadius: '8px',
          backgroundColor: '#000',
          color: 'white',
          fontFamily: 'Plus Jakarta Sans',
          fontSize: '14px',
          border: '1px solid #323232',
          pl: '12px',
          pr: '24px',
          display: 'flex',
          alignItems: 'center',
          '& .MuiSelect-select': {
            padding: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& .MuiSelect-icon': {
            color: 'white',
            right: '8px',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}